import { Copyrights, LanguageSelector } from '@/components/common';
import { isProdBuild } from '@/utils/env';

// Added 100px bottom margin in non-prod builds to avoid overlapping with DebugDrawer
const cls = `text-sm my-md flex flex-col xs:flex-row justify-center items-center mx-auto max-w-panel ${
  !isProdBuild ? 'mb-[100px]' : ''
}`;

export function Footer() {
  return (
    <div className={cls}>
      <LanguageSelector />
      <div className="flex mt-xs ml-0 xs:ml-8 xs:mt-0">
        <Copyrights />
      </div>
    </div>
  );
}
